import type { SelectCapitalizeProps, SelectItemProps } from '@/types/components/select'
import { cn } from '@/utils/cn'
import { Checkbox } from '../common/checkbox'
import { Label } from '../common/label'
import { PopoverListItem } from '../common/popover'
export const SelectItem = ({
  item,
  selectedItems,
  setSelectedItems,
  renderItemPrefix,
  itemFormatter,
  capitalize,
  className,
}: SelectItemProps & SelectCapitalizeProps) => {
  const isItemSelected = selectedItems.includes(item)
  const handleItemClick = () =>
    setSelectedItems(
      isItemSelected ? selectedItems.filter((itemInArray) => itemInArray !== item) : [...selectedItems, item]
    )

  return (
    <PopoverListItem className={cn('h-10 border-t first:border-none', className)}>
      <Label className={cn('flex h-full w-full max-w-full justify-between truncate px-3')}>
        <div className="flex max-w-full items-center gap-2 truncate">
          {renderItemPrefix?.(item)}
          <span
            className={cn('max-w-full truncate', capitalize && 'first-letter:uppercase')}
            title={itemFormatter ? itemFormatter(item) : item}
          >
            {itemFormatter ? itemFormatter(item) : item}
          </span>
        </div>
        <Checkbox onCheckedChange={handleItemClick} checked={isItemSelected} />
      </Label>
    </PopoverListItem>
  )
}
